import type { IValidatorDto } from "@/types/FormEngine/validation";
import type FormEngine from "../FormEngine";
import { default as FuncService } from "./FunctionalityService";
import { XmlHelper } from "@/helpers/Xml";

export default {
  genericFunction: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let f = new Function("$s", "func", FuncService.res("functionBody", func, $s) as string);
    //console.log("GENERIC FNUNC",$s);
    f($s, func);
    if (func.functionStack) {
      FuncService.builder(func.functionStack, $s)();
    }
  },
  ifStatement: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    if (FuncService.res("condition", func, $s)) {
      let cond = new Function("$s", "func", FuncService.res("condition", func, $s) as string);
      if (cond($s, func)) {
        if (func.ifStack) {
          FuncService.builder(func.ifStack, $s)();
        }
      } else {
        if (func.elseStack) {
          FuncService.builder(func.elseStack, $s)();
        }
      }
    } else {
      console.log("Condition is missing in ifStatement() FunctionalityLib.ts", func, $s);
    }
  },
  switchClause: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let functionStack: any[] = typeof func.functionStack !== "undefined" && Array.isArray(func.functionStack) ? func.functionStack : [];
    let defaultStack: any = typeof func.defaultStack !== "undefined" && Array.isArray(func.defaultStack) ? func.defaultStack : [];
    let input: string = func.switchCompareAttr ? $s[func.switchCompareAttr].getValue() : undefined;
    let defaultCond: boolean = true;

    functionStack.forEach((item) => {
      if (func.switchCompare && func.switchCompareAttr?.length) {
        if (item.Name === input) {
          FuncService.builder(item.functionStack, $s)();
          defaultCond = false;
        }
      } else {
        let cond = new Function("$s", "func", item.Name);
        if (cond($s, func)) {
          FuncService.builder(item.functionStack, $s)();
          defaultCond = false;
        }
      }
    });

    if (defaultCond) {
      FuncService.builder(defaultStack, $s)();
    }
  },
  // loop(this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
  //   if (func.data.targetables && func.functionStack) {
  //     for (let target in func.data.targetables) {
  //       // TODO: finish whole functionality for this
  //       FuncService.builder(func.functionStack, $s)();
  //     }
  //   }
  // },
  publishEvent(this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let control = this.form.controls.get(FuncService.res("targetId", func, $s));
    if (control) {
      //Todo: make optional;
      $s[FuncService.res("storageAttribute", func, $s)] = control;
      control.subscribe(FuncService.res("eventName", func, $s));
    } else {
      console.log("Control or function stack are not setup properly in subscribeOnEvent() FunctionalityLib.ts :", func, $s);
    }
  },

  subscribeOnEvent: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let control = this.form.controls.get(FuncService.res("targetId", func, $s));
    if (control && func.functionStack) {
      let specifier = FuncService.res("specifierName", func, $s);
      //Todo: make optional;
      $s[FuncService.res("storageAttribute", func, $s)] = control;
      control.subscribe(FuncService.res("eventName", func, $s), FuncService.builder(func.functionStack, $s,), (specifier) ? specifier : undefined);
    } else {
      console.log("Control or function stack are not setup properly in subscribeOnEvent() FunctionalityLib.ts :", func, $s);
    }
  },
  subscribeOnChange: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let control = this.form.controls.get(FuncService.res("targetId", func, $s));
    if (control && func.functionStack) {
      let specifier = FuncService.res("specifierName", func, $s);
      //Todo: make optional;
      $s[FuncService.res("storageAttribute", func, $s)] = control;
      control.subscribe(this.events.list.VALUE_CHANGE, FuncService.builder(func.functionStack, $s), (specifier) ? specifier : undefined);
    } else {
      console.log("Control or function stack are not setup properly in subscribeOnChange() FunctionalityLib.ts :", func, $s);
    }
  },

  //CONTROL STATE MANIPULATION

  hide: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.hide();
    } else {
      console.warn(
        "Target in hide() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  show: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.show();
    } else {
      console.warn(
        "Target in show() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  disable: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.disable();
    } else {
      console.warn(
        "Target in disable() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  enable: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.enable();
    } else {
      console.warn(
        "Target in enable() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  validate: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.validate();
    } else {
      console.warn(
        "Target in validate() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  reset: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.reset();
    } else {
      console.warn(
        "Target in reset() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  toggleHintSection: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.toggleHintSection();
    } else {
      console.warn(
        "Target in toggleHintSection() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  setOptionToNull: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.setOptionToNull();
    } else {
      console.warn(
        "Target in setOptionToNull() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },

  getOption: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    const attrName = func.data.optionValue;
    let input: string = attrName ? $s[attrName].getValue() : undefined;
    if (target) {
      target.getOption(input);
    } else {
      console.warn(
        "Target in getOption() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  disableOption: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    let input: string = FuncService.res("value", func, $s);
    if (target) {
      target.disableOption(input);
    } else {
      console.warn(
        "Target in disableOption() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  // ToDo Vytvorit v kontrolke tuto moznost.
  enableOption: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    let input: string = FuncService.res("value", func, $s);
    if (target) {
      target.enableOption(input);
    } else {
      console.warn(
        "Target in enableOption() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  // Get set
  getValue: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      target.getValue();
    } else {
      console.warn(
        "Target in getOption() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
    $s[FuncService.res("storageAttribute", func, $s)] = target.getValue();
  },
  setValue: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      target.setValue(FuncService.res("value", func, $s));
    } else {
      console.warn(
        "Target in setValue() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  setRequired: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      target.setRequired(FuncService.res("required", func, $s));
    } else {
      console.warn(
        "Target in setRequired() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  setToExport: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      target.setToExport(FuncService.res("toExport", func, $s));
    } else {
      console.warn(
        "Target in setToExport() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  pushError: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      target.pushError(FuncService.res("errorMessage", func, $s));
    } else {
      console.warn(
        "Target in pushError() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  pushErrorToTargetable: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      target.pushError(FuncService.res("errorMessage", func, $s));
    } else {
      console.warn(
        "Target in pushErrorToTargetable() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  resetErrors: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.resetErrors();
    } else {
      console.warn(
        "Target in resetErrors() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  removeError: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.removeError();
    } else {
      console.warn(
        "Target in removeError() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  getTargetable: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      $s[FuncService.res("storageAttribute", func, $s)] = target;
    } else {
      console.warn(
        "Target in getTargetable() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },

  newValidator: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let targetId = FuncService.res("targetId", func, $s);
    let target = null;
    if (targetId) {
      target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    }
    let identifier = FuncService.res("identifier", func, $s) as string;
    let validatorName = FuncService.res("validatorName", func, $s) as string;
    if (func.functionStack) {
      let validator = window.FormEngine.form.validation.newValidator($s, function (data: IValidatorDto) {
        $s.validatorDto = data;
        if (func.functionStack) {
          FuncService.builder(func.functionStack, $s)();
        }
        return $s.results;
      });
      //let validator = window.FormEngine.form.validation.newValidator($s, FuncService.builder(func.functionStack, $s));
      validator.validatorName = validatorName;
      window.FormEngine.form.validation.setValidator(validator, target && target.identifier ? target.identifier : identifier);
    } else {
      console.log("newValidator function has no functionStack", func, $s);
    }
  },
  rule:function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }){
    if (func.ruleStack) {
      FuncService.builder(func.ruleStack, $s)();
    }
  },
  removeValidator: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) { },
  setToStorage: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let storageAttribute = FuncService.res("storageAttribute", func, $s) as string;
    let value = FuncService.res("value", func, $s) as string;
    $s[storageAttribute] = value;
    //console.log($s);
  },

  openAccordion: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.state.parent.openAccordionTab();
    } else {
      console.warn(
        "Target in openAccordion() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  closeAccordion: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.state.parent.closeAccordionTab();
    } else {
      console.warn(
        "Target in closeAccordion() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  toggleAccordion: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s) as string);
    if (target) {
      target.state.parent.toggleAccordionTab();
    } else {
      console.warn(
        "Target in toggleAccordion() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  getSection: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      $s[FuncService.res("storageAttribute", func, $s)] = target;
    } else {
      console.warn(
        "Target in getSection() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },
  getControl: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let target = FuncService.getTarget(FuncService.res("targetId", func, $s));
    if (target) {
      let stroageAttr = FuncService.res("storageAttribute", func, $s);
      $s[stroageAttr ? stroageAttr : target.identifier] = target;
    } else {
      console.warn(
        "Target in getControl() FunctionalityLib.ts is not found for targetId => ",
        FuncService.res("targetId", func, $s),
        $s.$rule.functionName,
        $s
      );
    }
  },

  // CUSTOM BASE RULES
  setupTableCounterControl: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let tableTarget = FuncService.res("tableId", func, $s);
    let counterTarget = FuncService.res("targetId", func, $s);

    let counterControl = FuncService.getTarget(counterTarget);
    let tableControl = FuncService.getTarget(tableTarget);
    tableControl.config.counterControlIdentifier = counterTarget;
    counterControl.config.rowCounter = true;

    if (counterControl.mtdt.LDT.FieldType == "ComboBox" && counterControl.mtdt.LDT.LookupID == null) {
      // Need to fill options because ... 
      let generatedOptions = new Array<ILookup>;
      for (let optValue = 1; optValue <= tableControl.mtdt.MaxRepetition; optValue++) {
        let temp = {
          Value: optValue.toString(),
          Text: optValue.toString()
        } as ILookup
        generatedOptions.push(temp);
      }


      counterControl.defaultState.options = generatedOptions;
      counterControl.state.options = generatedOptions;
    }


    tableControl.subscribe(this.events.list.TABLE_ROW_REMOVE, function (data: any) {
      for (const stateValue in tableControl.state.value) {
        if (counterControl.config.connectedColumn) {
          tableControl.state.rows[stateValue].values.set(counterControl.config.connectedColumn, Number(stateValue) + 1);
        } else {
          let firstColumn = tableControl.mtdt.Tree[Object.keys(tableControl.mtdt.Tree)[0]].Identifier;
          tableControl.state.rows[stateValue].values.set(firstColumn, Number(stateValue) + 1);
        }

        tableControl.state.value[stateValue][counterTarget] = Number(stateValue) + 1;
      }
    });
    tableControl.subscribe(this.events.list.TABLE_DETAIL_OPEN, function (data: any) {
      if (data.action === "create") {
        counterControl.setValue(tableControl.state.value.length + 1, true);
      }
    });
    tableControl.mapDetailControlsRecursive();
  },
  setupDependantCombobox: function (this: FormEngine, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let childControl = FuncService.getTarget(FuncService.res("childId", func, $s));
    let parentControl = FuncService.getTarget(FuncService.res("parentId", func, $s));
    parentControl.subscribe(this.events.list.VALUE_CHANGE, function (data: any) {
      if (parentControl.getSelectedOption) {
        let val = childControl.state.value;
        let options = childControl.state.defaultOptions.filter((item: any, key: string) => {
          return item.ParentValue == parentControl.getSelectedOption.Value;
        });
        childControl.state.options = options;
        if (val) {
          childControl.setValue(val);
        }
      } else {
        childControl.state.options = childControl.state.defaultOptions;
      }
    });
  },
} as {
  [key: string]: Function;
};
